var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystemArrowDown = function SvgSystemArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 7
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "system-arrow-down_svg__a",
    d: "m8 0 8 7H0z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#system-arrow-down_svg__a",
    fill: "#4D4D4D",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 0 7)"
  })));
};
export { SvgSystemArrowDown as ReactComponent };